import React from "react";
import { Sparkles } from "lucide-react";

export const WinsList = ({ items = [] }) => {
  return (
    <div className="showcase-card p-5 sm:p-6" data-testid="recent-wins">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles
          size={18}
          strokeWidth={2}
          style={{ color: "#3F4F66" }}
          aria-hidden
        />
        <h2
          className="font-heading text-xl sm:text-2xl"
          style={{ color: "#1F1F1F", fontWeight: 600 }}
        >
          Recent wins
        </h2>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-muted-foreground">No recent wins to show yet.</p>
      ) : (
        <ul className="space-y-3">
          {items.map((win, idx) => (
            <li
              key={win.key || idx}
              className={`flex gap-4 items-start ${win.excluded_from_presentation ? "roadmap-win-excluded" : ""}`}
              data-excluded={Boolean(win.excluded_from_presentation)}
              data-testid={`win-item-${win.key || idx}`}
            >
              <span
                className="eyebrow shrink-0 pt-1"
                style={{ minWidth: "7rem", color: "#5C6E83" }}
              >
                {win.date_display}
              </span>
              <span className="text-sm leading-relaxed text-foreground">{win.summary}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default WinsList;
